import { PartialType, PickType } from '@nestjs/swagger';
import { SpModelNameUpdatableInterface } from '../interfaces/sp-model-name-updatable.interface';
import { SpModelNameDto } from './sp-model-name.dto';

export class SpModelNameUpdateDto
  extends PartialType(PickType(SpModelNameDto, ['active']))
  implements SpModelNameUpdatableInterface {}
